import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Chap = props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={6} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
             Hero Head
                <br />
                <Typography component="span" variant="inherit" color="primary">
           Chapter dx
                </Typography>
              </span>
            }
            subtitle="ChapterDx comprehensive HPV-STI assay is a proprietary NGS-based method that detects, genotypes and quantifies 28 HPVs and 13 STIs in a specimen. It is a single-tube and single-PCR method using type/species-specific primers for uniform amplification.


            "
            align="left"
            disableGutter
            titleVariant="h3"

            />
            <ul>
                <li>
                Detection and typing of 41 species/types
                </li>

                <li>
                Single tube and one-step PCR reaction


                </li>
                <li>
                Multiplex type-specific amplification
                </li>
                <li>
                Quantification of each species/type

                </li>
                <li>
                Internal control for each specimen

                </li>

                <li>
                User-friendly, simple workflow, and easy to automate (6 hours of benchwork/incubation time for 384 samples)
                </li>

                <li>
                	Dual indexing/barcoding for low, medium, and high-throughput sample scales

                </li>

                <li>
            Cost-efficient

                </li>

                <li>
                Includes data analysis software
                </li>

                
            </ul>

            <SectionHeader
            ctaGroup={[
              <Button variant="contained" color="primary" size="large">
                Quickbook
              </Button>,
              <Button variant="outlined" color="primary" size="large">
              Talk to us
              </Button>,
            ]}
            align="left"
            disableGutter
            titleVariant="h3"
          />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://ik.imagekit.io/j6phbjneuop/chapterdx_qyur3swpx0Y.png?updatedAt=1628297542880"
            alt="Chapter dx"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Chap.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Chap;
